import CONSTANTES from "../constantes";

export const reducerSesion = (state ={}, action) => {
  switch (action.type) {
    case CONSTANTES.ESTABLECER_SESION:
      return { ...state, logged: action.logged }
    case CONSTANTES.CHECK_USER:
      let userToken = localStorage.getItem('userToken');
      if (userToken) {
        return { ...state, logged: true }
      }
      else {
        return { ...state, logged: false }
      }
    case CONSTANTES.LOGOUT_USER:
      return { ...state, logged: false }
    default:
      return state;
  }
}

const stateUsuario = {
}
export const reducerUsuario = (state = stateUsuario, action) => {
  switch (action.type) {
    case CONSTANTES.OBTENER_USUARIO:
            return { ...state, usuario: action.usuario}
    default:
      return state
  }
}